import {
  ALL_ASSET_CLASSES,
  RISK_FACTOR_CONFIGS,
} from '@/portfolio/proposal-builder/config'
import {
  type ConfigKey,
  type ConventionalRiskFactorConfig,
  Field,
  type RiskFactor,
  RiskFactorConfigType,
} from '@/portfolio/proposal-builder/types'

/**
 * Computes which risk factors should be disabled based on the filtered asset classes
 * A risk factor is disabled if its relevantAssetClasses don't intersect with selected asset classes.
 */
export function computeDisabledRiskFactors(
  assetClassRiskFactor: RiskFactor,
): ConfigKey[] {
  const universeConstraint =
    assetClassRiskFactor.fields[Field.Type]?.universeConstraint

  const assetClassFilter = universeConstraint?.filter as
    | { type?: { in?: string[]; not_in?: string[] } }
    | undefined
  const filteredAssetClasses = assetClassFilter?.type?.in ?? ALL_ASSET_CLASSES

  const disabledRiskFactors = Object.values(RISK_FACTOR_CONFIGS)
    .filter((config) => {
      if (config.type !== RiskFactorConfigType.Conventional) return false
      const { relevantAssetClasses } = config as ConventionalRiskFactorConfig
      if (!relevantAssetClasses) return false
      return !relevantAssetClasses.some((ac) =>
        filteredAssetClasses.includes(ac),
      )
    })
    .map((config) => config.configKey)

  return disabledRiskFactors
}
